<template>
  <div class="app-wrapper">
    <app-main />
  </div>
</template>
<script>
import AppMain from '@/layouts/components/AppMain'
export default {
  name: 'Layout',
  components: {
    AppMain,
  },
  data () {
    return {
      btnShow:true
    }
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}
</script>
<style lang="scss" scoped>
@mixin clearfix {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
  background-color: #0d47a1;
}
</style>



// WEBPACK FOOTER //
// src/layouts/do.vue